import { format } from 'date-fns';
import { WPPost } from '../types/wordpress';

/** WordPress category "The ORBCoN Report" (slug newsletter) on transfusionontario.org. */
export const ORBCON_REPORT_CATEGORY_ID = 137;

export const ORBCON_REPORT_PATH = '/report';

export const ORBCON_REPORT_TITLE = 'The ORBCoN Report';

export const ORBCON_REPORT_NAV_LABEL = 'ORBCoN Report';

export interface ReportIssue {
  label: string;
  posts: WPPost[];
}

export function groupReportIssues(posts: WPPost[]): ReportIssue[] {
  const issues: ReportIssue[] = [];
  for (const post of posts) {
    const label = format(new Date(post.date), 'MMMM yyyy');
    const current = issues[issues.length - 1];
    if (current && current.label === label) {
      current.posts.push(post);
    } else {
      issues.push({ label, posts: [post] });
    }
  }
  return issues;
}
